import { Card, CardContent, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import React from "react";
import DoneIcon from '@mui/icons-material/Done';

const index = (props: { formValue: any }) => {

  return <div>
    <div className="lg:grid lg:grid-cols-3 lg:gap-3 grid grid-cols-1 gap-2">
      <Card>
        <CardContent>
          <Typography align="center" >Basic Info</Typography>
          <Typography><span className="font-bold">First Name</span>: {props.formValue?.firstName}</Typography>
          <Typography><span className="font-bold">Middle Name</span>: {props.formValue?.middleName}</Typography>
          <Typography><span className="font-bold">Last Name</span>: {props.formValue?.lastName}</Typography>
          <Typography><span className="font-bold">Gender</span>: {props.formValue?.gender}</Typography>
          <Typography><span className="font-bold">Phone Number</span>: {props.formValue?.phoneNo}</Typography>
          <Typography><span className="font-bold">Birth Date</span>: {new Date(props.formValue?.dob).toDateString()}</Typography>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Typography align="center">Risk Factors</Typography>
          {props.formValue?.riskandHabits?.risks !== undefined && props.formValue?.riskandHabits?.risks?.length > 0
            ?
            <List dense={true}>
              {
                props.formValue?.riskandHabits?.risks?.map((risk: string) => (
                  <>
                    <ListItem>
                      <ListItemIcon className=""><DoneIcon /></ListItemIcon>
                      <ListItemText>{risk}</ListItemText>
                    </ListItem>
                  </>
                ))
              }
            </List>
            :
            <span className="text-center">No Risk Entered</span>
          }
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Typography align="center">Habits</Typography>
          {props.formValue?.riskandHabits?.habits !== undefined && props.formValue?.riskandHabits?.risks?.length > 0
            ?
            <List dense={true}>
              {
                props.formValue?.riskandHabits?.habits?.map((habit: string) => (
                  <>
                    <ListItem>
                      <ListItemIcon className=""><DoneIcon /></ListItemIcon>
                      <ListItemText>{habit}</ListItemText>
                    </ListItem>
                  </>
                ))
              }
            </List>
            :
            <span className="text-center">No Habit Entered</span>
          }
        </CardContent>
      </Card>
    </div>
    <div className="grid grid-cols-1 gap-2 py-5">
      <div>
        <Typography align="center">Addresses</Typography>
        <div className="grid grid-cols-2 gap-2">
          {props.formValue?.addresses !== undefined ?
            props.formValue?.addresses?.map((address: any) => (
              <Card>
                <CardContent>
                  <Typography variant="body1"><span className="font-bold">Address Type</span>: {address?.addressType}</Typography>
                  <Typography variant="body1"><span className="font-bold">Value</span>: {address?.value}</Typography>
                </CardContent>
              </Card>
            ))
            :
            <span className="col-span-2 text-center">No Address Added</span>
          }
        </div>
      </div>
      {/* <div>
        <Typography align="center">Medical History</Typography>
        <Card>
          <CardContent className="grid grid-cols-2 gap-2">
            {props.formValue?.history !== undefined
              ?
              <>
                <span className="text-xs"><span className="font-bold">CC:</span> {props.formValue?.history.cc
                  ? props.formValue?.history.cc
                  : "----------"}</span>
                <span className="text-xs"><span className="font-bold">HPI:</span> {props.formValue?.history.hpi
                  ? props.formValue?.history.hpi
                  : "----------"}</span>
                <span className="text-xs"><span className="font-bold">PMHY:</span> {props.formValue?.history.pmhy
                  ? props.formValue?.history.pmhy
                  : "----------"}</span>
                <span className="text-xs"><span className="font-bold">PDHY:</span> {props.formValue?.history.pdhy
                  ? props.formValue?.history.pdhy
                  : "----------"}</span>
                <span className="text-xs"><span className="font-bold">GA:</span> {props.formValue?.history.ga
                  ? props.formValue?.history.ga
                  : "----------"}</span>
                <span className="text-xs"><span className="font-bold">IO:</span> {props.formValue?.history.io
                  ? props.formValue?.history.io
                  : "----------"}</span>
                <span className="text-xs"><span className="font-bold">EO:</span> {props.formValue?.history.eo
                  ? props.formValue?.history.eo
                  : "-----------"}</span>
                <span className="text-xs"><span className="font-bold">Asst:</span> {props.formValue?.history.asst
                  ? props.formValue?.history.asst
                  : "-----------"}</span>
                <span className="text-xs"><span className="font-bold">TyPlan:</span> {props.formValue?.history.tyPlan
                  ? props.formValue?.history.tyPlan
                  : "----------"}</span>
              </>
              :
              <span className="col-span-2 text-center">No Address Added</span>
            }
          </CardContent>
        </Card>
      </div> */}
    </div>
  </div>;
};

export default index;
